// for IE
import 'es6-promise/auto'
import 'whatwg-fetch'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import cognito from './cognito'
import VueI18n from 'vue-i18n'
import Notifications from 'vue-notification'
import VueAnalytics from 'vue-analytics'
Vue.config.productionTip = false

// notification
Vue.use(Notifications)  

// i18n
Vue.use(VueI18n)
const message = require('./message.json');
const i18n = new VueI18n({
  locale: 'ja',
  messages: message
});

// analytics
Vue.use(VueAnalytics, {
  id: process.env.GA_ID,
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  cognito,
  template: '<App/>',
  components: { App },
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js